import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import {requestGroupPipelineByStragyCompaignNextDVTJCUV} from "@pages/dvtjcuv/service/DVTJCUVFollowUpService";
import DVTJCUVPipelineNextStragyCompaignGroupItemList
    from "@pages/dvtjcuv/rundvtjcuv/DVTJCUVPipelineNextStragyCompaignGroupItemList";
import DVTJCUVEmailInviteModal, {EmailInviteMode} from "@pages/candidate/list/DVTJCUVEmailInviteModal";

const DVTJCUVPipelineNextStragyCompaignGroupList = (props) => {
    const [groups, setGroups] = useState([]);
    const [selectedPipelines, setSelectedPipelines] = useState([]);
    const [showFollowUpModal, setShowFollowUpModal] = useState(false);

    const {pipelineIds, parentTab, mode} = props
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const fetchGroupList = async (ids) => {
        const res = await requestGroupPipelineByStragyCompaignNextDVTJCUV({pipeline_ids: ids, invite_mode: mode});
        setGroups(res.content.groups);
    }

    const onEmailFU = async (pipelines) => {
        // await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage, true)
        setSelectedPipelines(pipelines)
        setShowFollowUpModal(true)
    }

    const onSendEmailInviteJob = async (candidateIds) => {
        // let requestData = {run_job_id: runJobInfo.id, candidate_ids: candidateIds, job_id: runJobInfo.job_id}
        // await requestSendEmailInviteJob(requestData)
        // await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }


    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    useEffect(() => {
        if (pipelineIds && pipelineIds.length > 0) {
            fetchGroupList(pipelineIds, parentTab).then()
        }

    }, [pipelineIds, parentTab]);

    return (
        <>
            {groups.map((group, i) => (
                <DVTJCUVPipelineNextStragyCompaignGroupItemList
                    pipelineIds={group.pipeline_ids}
                    nextFUStrategy={group.g_next_fu_strategy_date_time}
                    nextFUCompaign={group.g_next_fu_campaign}
                    parentTab={parentTab}
                    onEmailFU={onEmailFU}
                    mode={mode}
                />
            ))}

            {showFollowUpModal &&
                <DVTJCUVEmailInviteModal candidateIds={[...new Set(selectedPipelines.map(item => item.cdd_id))]}
                                         pipelines={selectedPipelines}
                                         mode={mode ?? EmailInviteMode.INVITE_EMAIL_FU}
                                         onClose={() => setShowFollowUpModal(false)}
                                         isShow={showFollowUpModal}/>
            }
        </>
    )
}

export default DVTJCUVPipelineNextStragyCompaignGroupList;
